const Url = 'https://hoster.dprimeramano.com/public/';
//const Url = 'http://localhost/hoster_backend/public/';

export  {Url} ;